module.exports = __webpack_public_path__ + "img/briefcase.a43e9072.svg";